/**
 * Map lucide icon slug (e.g. "shield-check") to the actual React component
 * from lucide-react. We only import the icons the reference uses, plus a
 * generic fallback. Keeping this in one place lets the SectionRenderer be pure.
 */
import {
  ArrowRight,
  ArrowUpRight,
  BadgeCheck,
  Building2,
  ClipboardCheck,
  Compass,
  Factory,
  FileCheck2,
  Globe,
  GraduationCap,
  HandHeart,
  HeartPulse,
  Landmark,
  Layers,
  Lock,
  Microscope,
  Network,
  ShieldCheck,
  ShipWheel,
  Sparkles,
  Timer,
  Truck,
  Utensils,
  Warehouse,
  Wheat,
  Zap,
} from "lucide-react";

const MAP = {
  "shield-check": ShieldCheck,
  "compass": Compass,
  "clipboard-check": ClipboardCheck,
  "layers": Layers,
  "file-check2": FileCheck2,
  "file-check-2": FileCheck2,
  "truck": Truck,
  "network": Network,
  "microscope": Microscope,
  "ship-wheel": ShipWheel,
  "factory": Factory,
  "heart-pulse": HeartPulse,
  "utensils": Utensils,
  "building2": Building2,
  "building-2": Building2,
  "zap": Zap,
  "wheat": Wheat,
  "hand-heart": HandHeart,
  "landmark": Landmark,
  "warehouse": Warehouse,
  "graduation-cap": GraduationCap,
  "badge-check": BadgeCheck,
  "arrow-right": ArrowRight,
  "arrow-up-right": ArrowUpRight,
  "timer": Timer,
  "lock": Lock,
  "globe": Globe,
};

export function Icon({ name, className = "" }) {
  const Cmp = (name && MAP[name]) || Sparkles;
  return <Cmp className={className} aria-hidden />;
}
